import { TemplateService } from 'src/app/service/template.service';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
  @Input('loading') loading: Boolean = false
  constructor(public template: TemplateService) { }

  ngOnInit(): void {
  }

}
